import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { PremissionChecker } from "../../../services/PremissionChecker";
import Select from "react-select";
function AddSchoolAccounts() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [error, setError] = useState("Please fill or select required fields");
  const [isallfields, setisallfields] = useState(false);

  const [schoolAccountData, setSchoolAccountData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);
  const [recvSubAccountList, setRecvSubAccountList] = useState([]);
  const [recvSubAccountGroup, setRecvSubAccountGroup] = useState([]);
  const [royaltySubAccountList, setRoyaltySubAccountList] = useState([]);
  const [royaltySubAccountGroup, setRoyaltySubAccountGroup] = useState([]);
  const [addRegionLoading, setAddRegionLoading] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [customerId, setCustomerId] = useState("");

  const [addModal, setAddModal] = useState(false);
  const [schoolName, setSchoolName] = useState("");
  const [averageFee, setAverageFee] = useState(0);
  const [schoolStrength, setSchoolStrength] = useState(0);
  const [royaltyPercentage, setRoyaltyPercentage] = useState(0);
  const [regionId, setRegionId] = useState("");
  const [recvSubAccountId, setRecvSubAccountId] = useState("");
  const [royaltySubAccountId, setRoyaltySubAccountId] = useState("");
  const [estimatedMonthlyRoyalty, setEstimatedMonthlyRoyalty] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [contactRemarks, setContactRemarks] = useState("");
  const [status, setStatus] = useState(true);

  const [addAccount, setAddAccount] = useState(false);
  const [addRoyaltyAccount, setAddRoyaltyAccount] = useState(false);
  const [accountChartId, setAccountChartId] = useState("");
  const [addAccountLoading, setAddAccountLoading] = useState(false);
  const [acode, setAcode] = useState("");
  const [title, setTitle] = useState("");

  const [editModal, setEditModal] = useState(false);
  const [editCustomerId, setEditCustomerId] = useState("");
  const [editSchoolAccountId, setEditSchoolAccountId] = useState("");
  const [editSchoolName, setEditSchoolName] = useState("");
  const [editAverageFee, setEditAverageFee] = useState(0);
  const [editSchoolStrength, setEditSchoolStrength] = useState(0);
  const [editRoyaltyPercentage, setEditRoyaltyPercentage] = useState(0);
  const [editRegionId, setEditRegionId] = useState("");
  const [editRecvSubAccountId, setEditRecvSubAccountId] = useState("");
  const [editRoyaltySubAccountId, setEditRoyaltySubAccountId] = useState("");
  const [
    editEstimatedMonthlyRoyalty,
    setEditEstimatedMonthlyRoyalty,
  ] = useState("");
  const [editContactNo, setEditContactNo] = useState("");
  const [editContactEmail, setEditContactEmail] = useState("");
  const [editContactPerson, setEditContactPerson] = useState("");
  const [editContactRemarks, setEditContactRemarks] = useState("");
  const [editStatus, setEditStatus] = useState(true);

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteSchoolAccountId, setDeleteSchoolAccountId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  useEffect(() => {
    getSchoolAccounts();
    getRegions();
    getCustomers();
    getRecvSubAccounts();
    getRoyaltySubAccounts();
  }, []);

  const getSchoolAccounts = async () => {
    setloading(true);
    await fetch(`${baseUrl}/school-accounts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setSchoolAccountData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getRegions = async () => {
    await fetch(`${baseUrl}/regions`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          let arr = [];
          data.payload.forEach((element) => {
            arr.push({
              label: element.name,
              value: element.id,
            });
          });
          setRegionsData(arr);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getCustomers = async () => {
    await fetch(`https://portal.tvoschool.com/api/customers`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          let arr = [];
          data.data.forEach((element) => {
            arr.push({
              label: element.name,
              value: element.id,
            });
          });
          setCustomerList(arr);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getRecvSubAccounts = async () => {
    try {
      const res = await fetch(`${baseUrl}/receivable-sub-account`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      });

      const data = await res.json();

      /* ---------------- NORMAL LIST ---------------- */
      const subAccountList = data.payload.map((el) => ({
        label: `${el.title} (${el.acode})`,
        value: el.id,
        account_chart_id: el.account_chart_id,
      }));

      setRecvSubAccountList(subAccountList);

      /* ---------------- GROUPED LIST ---------------- */
      const grouped = Object.values(
        data.payload.reduce((acc, el) => {
          const chart = el.account_chart;

          if (!chart) return acc;

          const key = chart.id;

          if (!acc[key]) {
            acc[key] = {
              label: `${chart.title} (${el.acode})`,
              value: chart.id, // account_chart_id
              last_acode: el.acode,
            };
          } else if (el.acode > acc[key].last_acode) {
            acc[key].last_acode = el.acode;
            acc[key].label = `${chart.title} (${el.acode})`;
          }

          return acc;
        }, {}),
      );
      setRecvSubAccountGroup(grouped);
    } catch (err) {
      alert.error(err);
    }
  };

  const getRoyaltySubAccounts = async () => {
    try {
      const res = await fetch(`${baseUrl}/royalty-sub-account`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      });

      const data = await res.json();

      /* ---------------- NORMAL LIST ---------------- */
      const subAccountList = data.payload.map((el) => ({
        label: `${el.title} (${el.acode})`,
        value: el.id,
        account_chart_id: el.account_chart_id,
      }));

      setRoyaltySubAccountList(subAccountList);

      /* ---------------- GROUPED LIST ---------------- */
      const grouped = Object.values(
        data.payload.reduce((acc, el) => {
          const chart = el.account_chart;

          if (!chart) return acc;

          const key = chart.id;

          if (!acc[key]) {
            acc[key] = {
              label: `${chart.title} (${el.acode})`,
              value: chart.id, // account_chart_id
              last_acode: el.acode,
            };
          } else if (el.acode > acc[key].last_acode) {
            acc[key].last_acode = el.acode;
            acc[key].label = `${chart.title} (${el.acode})`;
          }

          return acc;
        }, {}),
      );
      setRoyaltySubAccountGroup(grouped);
    } catch (err) {
      alert.error(err);
    }
  };

  const addSchoolAccountHandler = async () => {
    if (
      schoolName == "" ||
      regionId == "" ||
      recvSubAccountId == "" ||
      royaltySubAccountId == "" ||
      averageFee == "" ||
      schoolStrength == "" ||
      royaltyPercentage == "" ||
      estimatedMonthlyRoyalty == ""
    ) {
      setError("Please fill or select required fields");
      setisallfields(true);
      return;
    }

    if (contactEmail != "" && !isValidEmail(contactEmail)) {
      setError("Invalid email address");
      setisallfields(true);
      return;
    } else {
      setisallfields(false);
    }

    setisallfields(false);
    const data = {
      region_id: regionId,
      customer_id: customerId,
      receiveable_sub_account_id: recvSubAccountId,
      royalty_sub_account_id: royaltySubAccountId,
      school_name: schoolName,
      average_fee: averageFee,
      school_strength: schoolStrength,
      royalty_percentage: royaltyPercentage,
      estimated_monthly_royalty: estimatedMonthlyRoyalty,
      contact_person: contactPerson,
      contact_number: contactNo,
      contact_email: contactEmail,
      contact_remarks: contactRemarks,
      status: status ? 1 : 0,
    };
    setAddRegionLoading(true);

    await fetch(`${baseUrl}/school-accounts`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("School Account successfully added");
            setAddModal(false);
            setAddRegionLoading(false);
            getSchoolAccounts();
            setRegionId("");
            setCustomerId("");
            setRecvSubAccountId("");
            setRoyaltySubAccountId("");
            setSchoolName("");
            setAverageFee(0);
            setSchoolStrength(0);
            setRoyaltyPercentage(0);
            setEstimatedMonthlyRoyalty("");
            setContactPerson("");
            setContactEmail("");
            setContactNo("");
            setContactRemarks("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddModal(false);
            setAddRegionLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddModal(false);
            setAddRegionLoading(false);
          }
        }),
      )
      .catch((err) => {
        setAddRegionLoading(false);
        setAddModal(false);
        console.log(err);
      });
  };

  const addAccountHandler = async () => {
    if (title == "" || acode == "" || accountChartId == "") {
      setError("Please fill or select required fields");
      setisallfields(true);
      return;
    }

    setisallfields(false);
    const data = {
      account_chart_id: accountChartId,
      acode: acode,
      title: title,
    };
    setAddAccountLoading(true);

    await fetch(`${baseUrl}/subaccount`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Sub Account successfully added");
            setAddAccount(false);
            setAddAccountLoading(false);
            addRoyaltyAccount ? getRoyaltySubAccounts() : getRecvSubAccounts();
            setAccountChartId("");
            setAcode("");
            setTitle("");
            setAddRoyaltyAccount(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddAccount(false);
            setAddAccountLoading(false);
            setAddRoyaltyAccount(false);
          } else {
            alert.show("Something Went Wrong");
            setAddAccount(false);
            setAddAccountLoading(false);
            setAddRoyaltyAccount(false);
          }
        }),
      )
      .catch((err) => {
        setAddAccountLoading(false);
        setAddAccount(false);
        setAddRoyaltyAccount(false);
        console.log(err);
      });
  };

  const getEditSchoolAccounts = async (id) => {
    await fetch(`${baseUrl}/school-accounts/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditRegionId(data.payload?.region_id ?? "");
          setEditCustomerId(data.payload?.customer_id ?? "");
          setEditRecvSubAccountId(
            data.payload?.receiveable_sub_account_id ?? "",
          );
          setEditRoyaltySubAccountId(
            data.payload?.royalty_sub_account_id ?? "",
          );
          setEditSchoolName(data.payload?.school_name ?? "");
          setEditAverageFee(data.payload?.average_fee ?? "");
          setEditSchoolStrength(data.payload?.school_strength ?? "");
          setEditRoyaltyPercentage(data.payload?.royalty_percentage ?? "");
          setEditEstimatedMonthlyRoyalty(
            data.payload?.estimated_monthly_royalty ?? "",
          );
          setEditContactPerson(data.payload?.contact_person ?? "");
          setEditContactNo(data.payload?.contact_number ?? "");
          setEditContactEmail(data.payload?.contact_email ?? "");
          setEditContactRemarks(data.payload?.contact_remarks ?? "");
          setStatus(data.payload?.status == 1 ? true : false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateSchoolAccountHandler = async () => {
    if (editRegionId == "") {
      setError("Region Is Required");
      setisallfields(true);
      return;
    }

    if (editRecvSubAccountId == "") {
      setError("Receiveable Sub Account ID Is Required");
      setisallfields(true);
      return;
    }

    if (editRoyaltySubAccountId == "") {
      setError("Royalty Sub Account ID Is Required");
      setisallfields(true);
      return;
    }

    if (editSchoolName == "") {
      setError("School Name Is Required");
      setisallfields(true);
      return;
    }

    if (
      editAverageFee == 0 ||
      editSchoolStrength == 0 ||
      editRoyaltyPercentage == 0
    ) {
      setError(
        "Average Fee, School Strength and Royalty Percentage Must be greater than 0",
      );
      setisallfields(true);
      return;
    }

    if (editEstimatedMonthlyRoyalty == "") {
      setError("Estimated Monthly Royalty Is Required");
      setisallfields(true);
      return;
    }

    if (editContactEmail != "" && !isValidEmail(editContactEmail)) {
      setError("Invalid email address");
      setisallfields(true);
      return;
    } else {
      setisallfields(false);
    }

    setSubmitLoading(true);
    const data = {
      region_id: editRegionId,
      customer_id: editCustomerId,
      receiveable_sub_account_id: editRecvSubAccountId,
      royalty_sub_account_id: editRoyaltySubAccountId,
      school_name: editSchoolName,
      average_fee: editAverageFee,
      school_strength: editSchoolStrength,
      royalty_percentage: editRoyaltyPercentage,
      estimated_monthly_royalty: editEstimatedMonthlyRoyalty,
      contact_person: editContactPerson,
      contact_number: editContactNo,
      contact_email: editContactEmail,
      contact_remarks: editContactRemarks,
      status: editStatus ? 1 : 0,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/school-accounts/${editSchoolAccountId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("School Account Successfully Updated");
            getSchoolAccounts();
            setEditModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(data.metadata.message);
            });
            setEditModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteSchoolAccountHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/school-accounts/${deleteSchoolAccountId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.metadata.message);
            getSchoolAccounts();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  const calculateRoyalty = () => {
    if (averageFee == 0 || schoolStrength == 0 || royaltyPercentage == 0) {
      setError(
        "Average Fee, School Strength and Royalty Percentage Must be greater than 0",
      );
      setisallfields(true);
      return;
    }
    let royalty = (averageFee * schoolStrength * royaltyPercentage) / 100;
    setEstimatedMonthlyRoyalty(royalty);
  };

  const editCalculateRoyalty = () => {
    if (
      editAverageFee == 0 ||
      editSchoolStrength == 0 ||
      editRoyaltyPercentage == 0
    ) {
      setError(
        "Average Fee, School Strength and Royalty Percentage Must be greater than 0",
      );
      setisallfields(true);
      return;
    }
    let royalty =
      (editAverageFee * editSchoolStrength * editRoyaltyPercentage) / 100;
    setEditEstimatedMonthlyRoyalty(royalty);
  };
  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {PremissionChecker(user, "school_account.add") && (
          <div>
            <button
              onClick={() => setAddModal(true)}
              className="btn btn-primary mr-2"
            >
              Add School Account
            </button>
          </div>
        )}

        <div
          className="table-responsive"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <Table className="mt-5" style={{ width: "max-content" }}>
            <thead>
              <tr className="text-center">
                <th>ID</th>
                <th>School Name</th>
                <th>Customer Name</th>
                <th>Region Name</th>
                <th>Receiveable Account</th>
                <th>Royalty Account</th>
                <th>Average Fee</th>
                <th>School Strength</th>
                <th>Royalty Percentage</th>
                <th>Estimated Monthly Royalty</th>
                <th>Contact Person</th>
                <th>Contact Email</th>
                <th>Contact No.</th>
                <th>Contact Remarks</th>
                <th>Status</th>
                {PremissionChecker(user, "school_account.update") && (
                  <th>Update</th>
                )}
                {PremissionChecker(user, "school_account.delete") && (
                  <th>Delete</th>
                )}
              </tr>
            </thead>
            <tbody>
              {schoolAccountData?.map((school, index) => (
                <tr className="text-center" key={index}>
                  <td>{school?.id}</td>
                  <td>{school?.school_name}</td>
                  <td>
                    {customerList.find(
                      (customer) => customer.value == school?.customer_id,
                    )?.label ?? "---"}
                  </td>
                  <td>{school?.region?.name}</td>
                  <td>
                    {school?.receiveable_sub_account?.title +
                      ` (${school?.receiveable_sub_account?.acode})` ?? "---"}
                  </td>
                  <td>
                    {school?.royalty_sub_account?.title +
                      ` (${school?.royalty_sub_account?.acode})` ?? "---"}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-Us").format(school?.average_fee)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-Us").format(school?.school_strength)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-Us").format(
                      school?.royalty_percentage,
                    )}
                    %
                  </td>
                  <td>
                    {Intl.NumberFormat("en-Us").format(
                      school?.estimated_monthly_royalty,
                    )}
                  </td>
                  <td>{school?.contact_person ?? "---"}</td>
                  <td>{school?.contact_email ?? "---"}</td>
                  <td>{school?.contact_number ?? "---"}</td>
                  <td>{school?.contact_remarks ?? "---"}</td>
                  <td>{school?.status ? "Active" : "Inactive"}</td>
                  {PremissionChecker(user, "school_account.update") && (
                    <td>
                      <a
                        className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                        onClick={() => {
                          getEditSchoolAccounts(school?.id);
                          setEditSchoolAccountId(school?.id);
                          setEditModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Write.svg",
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  )}

                  {PremissionChecker(user, "school_account.delete") && (
                    <td>
                      <a
                        className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                        onClick={() => {
                          setDeleteSchoolAccountId(school?.id);
                          setdeleteModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Delete-user.svg",
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add School Account Modal */}
        <Modal show={addModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New School Account
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Region <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <Select
                  onChange={(e) => setRegionId(e.value)}
                  placeholder="Select Region"
                  options={regionsData}
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Receiveable Sub Account{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <div className="row">
                  <div className="col-11">
                    <Select
                      onChange={(e) => setRecvSubAccountId(e.value)}
                      placeholder="Select Receiveable Sub Account"
                      options={recvSubAccountList}
                    />
                  </div>
                  <a
                    className="col-1 mt-1 btn btn-icon btn-light btn-hover-primary-custom btn-sm"
                    onClick={() => {
                      setAddAccount(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                      />
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Royalty Sub Account{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <div className="row">
                  <div className="col-11">
                    <Select
                      onChange={(e) => setRoyaltySubAccountId(e.value)}
                      placeholder="Select Royalty Sub Account"
                      options={royaltySubAccountList}
                    />
                  </div>
                  <a
                    className="col-1 mt-1 btn btn-icon btn-light btn-hover-primary-custom btn-sm"
                    onClick={() => {
                      setAddRoyaltyAccount(true);
                      setAddAccount(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                      />
                    </span>
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Select Customer</b>
                </label>
                <Select
                  onChange={(e) => setCustomerId(e.value)}
                  placeholder="Select Customer"
                  options={customerList}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter School Name <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={schoolName}
                  onChange={(e) => setSchoolName(e.target.value)}
                  placeholder="Enter School Name"
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Average Fee <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={averageFee}
                  onChange={(e) => setAverageFee(e.target.value)}
                  placeholder="Enter Average Fee"
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter School Strength{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={schoolStrength}
                  onChange={(e) => setSchoolStrength(e.target.value)}
                  placeholder="Enter School Strength"
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Royalty Percentage</b>
                </label>
                <input
                  className="form-control"
                  value={royaltyPercentage}
                  onChange={(e) => setRoyaltyPercentage(e.target.value)}
                  placeholder="Enter Royalty Percentage"
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Estimated Monthly Royalty{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <div className="row">
                  <div className="col-8">
                    <input
                      className="form-control"
                      value={estimatedMonthlyRoyalty}
                      onChange={(e) =>
                        setEstimatedMonthlyRoyalty(e.target.value)
                      }
                      placeholder="Enter Est. Monthly Royalty"
                    />
                  </div>
                  <button
                    className="btn btn-primary col-4"
                    onClick={calculateRoyalty}
                  >
                    Calculate
                  </button>
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Contact Person</b>
                </label>
                <input
                  className="form-control"
                  value={contactPerson}
                  onChange={(e) => setContactPerson(e.target.value)}
                  placeholder="Enter Contact Person"
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Contact Email</b>
                </label>
                <input
                  className="form-control"
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                  placeholder="Enter Contact Email"
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Contact No.</b>
                </label>
                <input
                  className="form-control"
                  value={contactNo}
                  onChange={(e) => setContactNo(e.target.value)}
                  placeholder="Enter Contact No."
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-9">
                <label className="form-control-label">
                  <b>Enter Contact Remarks</b>
                </label>
                <input
                  className="form-control"
                  value={contactRemarks}
                  onChange={(e) => setContactRemarks(e.target.value)}
                  placeholder="Enter Contact Remarks"
                />
              </div>
              <div className="col-md-3 pb-4 mt-9">
                <label className="checkbox checkbox-single">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    id="status"
                    checked={status ? true : false}
                    onChange={(e) => setStatus(e.target.checked ? true : false)}
                  />
                  <span />
                  &nbsp;&nbsp;&nbsp;Is Active
                </label>
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{error}</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addRegionLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addSchoolAccountHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddModal(false);
                setisallfields(false);
                setRegionId("");
                setEditCustomerId("");
                setRecvSubAccountId("");
                setRoyaltySubAccountId("");
                setSchoolName("");
                setEditAverageFee(0);
                setSchoolStrength(0);
                setRoyaltyPercentage(0);
                setEstimatedMonthlyRoyalty("");
                setContactPerson("");
                setContactEmail("");
                setContactNo("");
                setContactRemarks("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Add School Account Modal */}
        <Modal show={addAccount} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              {addRoyaltyAccount
                ? "Add Royalty Account"
                : "Add Receiveable Account"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              {!addRoyaltyAccount && (
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Select Receiveable Sub Account{" "}
                      <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <Select
                    onChange={(e) => {
                      setAccountChartId(e.value);
                      setAcode(e.last_acode + 1);
                    }}
                    placeholder="Select Receiveable Sub Account"
                    options={recvSubAccountGroup}
                  />
                </div>
              )}

              {addRoyaltyAccount && (
                <div className="col-md-6">
                  <label className="form-control-label">
                    <b>
                      Select Royalty Sub Account{" "}
                      <span style={{ color: "red" }}>*</span>{" "}
                    </b>
                  </label>
                  <Select
                    onChange={(e) => {
                      setAccountChartId(e.value);
                      setAcode(e.last_acode + 1);
                    }}
                    placeholder="Select Royalty Sub Account"
                    options={royaltySubAccountGroup}
                  />
                </div>
              )}

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Acode <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={acode}
                  onChange={(e) => setAcode(e.target.value)}
                  placeholder="Enter Sub Account Acode"
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-12">
                <label className="form-control-label">
                  <b>
                    Enter Title <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter Sub Account Title"
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{error}</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addAccountLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addAccountHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddAccount(false);
                setisallfields(false);
                setAccountChartId("");
                setAcode("");
                setTitle("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update School Account Modal */}
        <Modal show={editModal} size="lg">
          <Modal.Header>
            <Modal.Title>Update School Account</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Region <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <Select
                  value={
                    regionsData.find((opt) => opt.value == editRegionId) || ""
                  }
                  onChange={(e) => setEditRegionId(e.value)}
                  placeholder="Select Region"
                  options={regionsData}
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Receiveable Sub Account{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <div className="row">
                  <div className="col-11">
                    <Select
                      value={
                        recvSubAccountList.find(
                          (opt) => opt.value == editRecvSubAccountId,
                        ) || ""
                      }
                      onChange={(e) => setEditRecvSubAccountId(e.value)}
                      placeholder="Select Receiveable Sub Account"
                      options={recvSubAccountList}
                    />
                  </div>
                  <a
                    className="col-1 mt-1 btn btn-icon btn-light btn-hover-primary-custom btn-sm"
                    onClick={() => {
                      setAddAccount(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                      />
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Royalty Sub Account{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <div className="row">
                  <div className="col-11">
                    <Select
                      value={
                        royaltySubAccountList.find(
                          (opt) => opt.value == editRoyaltySubAccountId,
                        ) || ""
                      }
                      onChange={(e) => setEditRoyaltySubAccountId(e.value)}
                      placeholder="Select Royalty Sub Account"
                      options={royaltySubAccountList}
                    />
                  </div>
                  <a
                    className="col-1 mt-1 btn btn-icon btn-light btn-hover-primary-custom btn-sm"
                    onClick={() => {
                      setAddRoyaltyAccount(true);
                      setAddAccount(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                      />
                    </span>
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Select Customer</b>
                </label>
                <Select
                  value={
                    customerList.find((opt) => opt.value == editCustomerId) ||
                    ""
                  }
                  onChange={(e) => setEditCustomerId(e.value)}
                  placeholder="Select Customer"
                  options={customerList}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter School Name <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editSchoolName}
                  onChange={(e) => setEditSchoolName(e.target.value)}
                  placeholder="Enter School Name"
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Average Fee <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editAverageFee}
                  onChange={(e) => setEditAverageFee(e.target.value)}
                  placeholder="Enter Average Fee"
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter School Strength{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editSchoolStrength}
                  onChange={(e) => setEditSchoolStrength(e.target.value)}
                  placeholder="Enter School Strength"
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Royalty Percentage</b>
                </label>
                <input
                  className="form-control"
                  value={editRoyaltyPercentage}
                  onChange={(e) => setEditRoyaltyPercentage(e.target.value)}
                  placeholder="Enter Royalty Percentage"
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Estimated Monthly Royalty{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <div className="row">
                  <div className="col-8">
                    <input
                      className="form-control"
                      value={editEstimatedMonthlyRoyalty}
                      onChange={(e) =>
                        setEditEstimatedMonthlyRoyalty(e.target.value)
                      }
                      placeholder="Enter Estimated Monthly Royalty"
                    />
                  </div>
                  <button
                    className="btn btn-primary col-4"
                    onClick={editCalculateRoyalty}
                  >
                    Calculate
                  </button>
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Contact Person</b>
                </label>
                <input
                  className="form-control"
                  value={editContactPerson}
                  onChange={(e) => setEditContactPerson(e.target.value)}
                  placeholder="Enter Contact Person"
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Contact Email</b>
                </label>
                <input
                  className="form-control"
                  value={editContactEmail}
                  onChange={(e) => setEditContactEmail(e.target.value)}
                  placeholder="Enter Contact Email"
                />
              </div>
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>Enter Contact No.</b>
                </label>
                <input
                  className="form-control"
                  value={editContactNo}
                  onChange={(e) => setEditContactNo(e.target.value)}
                  placeholder="Enter Contact No."
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-9">
                <label className="form-control-label">
                  <b>Enter Contact Remarks</b>
                </label>
                <input
                  className="form-control"
                  value={editContactRemarks}
                  onChange={(e) => setEditContactRemarks(e.target.value)}
                  placeholder="Enter Contact Remarks"
                />
              </div>
              <div className="col-md-3 pb-4 mt-9">
                <label className="checkbox checkbox-single">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    id="status"
                    checked={editStatus == 1 ? true : false}
                    onChange={(e) =>
                      setEditStatus(e.target.checked ? true : false)
                    }
                  />
                  <span />
                  &nbsp;&nbsp;&nbsp;Is Active
                </label>
              </div>
            </div>
            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{error}</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateSchoolAccountHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete School Account Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this school account?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                School Account Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteSchoolAccountHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default AddSchoolAccounts;
